const styles = () => ({
  root: {
    padding: "50px 100px",
    position: "relative",
    top: 180,
    display: "flex",
    justifyContent: "center",
  },
  textField: {
    marginTop: 16,
  },
  card: {
    margin: "auto",
    padding: 10,
    display: "flex",
    width: "100%",
    background: "#f5f5f5",
  },
  background: {
    position: "absolute",
    height: 350,
    width: "100%",
    top: 0,
    background: "#141b2f",
  },
  logo: {
    padding: 60,
  },
  center: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
  },
  button: {
    background: "#11497e",
    color: "#FFFF",
    width: "100%",
  },
  backgroundButton: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    justifyContent: "center",
  },
  forgotPassword: {
    justifyContent: "center",
    alignItems: 'center',
    marginTop: 15,
    width: '100%'
  },
  progress: {
    color: "#FFF",
  },
});

export default styles;
